import React from 'react';
import { Link } from 'react-router-dom';
import { Markup } from 'interweave';

import styles from '../../App.module.css';
import noThumb from "../../images/no-thumb.jpg";

function VideoBox(video) {
    let thumb = null;
    if(video.thumb.includes('storage/media/thumbs/')) {
        thumb = `${process.env.REACT_APP_API_URL}/${video.thumb}`;
    }else {
        thumb = video.thumb;
    }
  return (
    <div className={styles.videoitem}>
        <div className="video">
            <div className={styles.video_thumb}>
                <Link className={styles.clip_link} to={`/video/${video.id}/${video.nice_url || video.title.toLowerCase().replace(/[^A-Z0-9]+/ig, "-")}`}>
                    <img src={thumb} onError={e => {e.target.src = noThumb}} alt={video.title} />
                </Link>
                {
                    video.duration > 0 && <div className={styles.time}>{video.video_time}</div>
                }
            </div>
            <div className={styles.video_data}>
                <div className={styles.video_title}>
                    <Link to={`/video/${video.id}/${video.nice_url || video.title.toLowerCase().replace(/[^A-Z0-9]+/ig, "-")}`}><Markup content={video.title}></Markup></Link>
                </div>
                <div className={styles.stats}>
                <div className={styles.uploaderlink}>
                    <Link to={`/profile/${video.user_id}/${video.username || (video.name && video.name.toLowerCase().replace(/[^A-Z0-9]+/ig, "-"))}`}><Markup content={video.name || video.owner}></Markup></Link>
                </div>
                <ul className={styles.meta}>
                    <li>{video.views} views</li>
                    <li>·</li>
                    <li>{video.time_ago}</li>
                </ul>
                </div>
            </div>
        </div>
    </div>
  )
}

export default VideoBox